/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const networkInfrastructureEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type NetworkInfrastructureEnumsPotentialConsequenceOptionEnumKey =
    (typeof networkInfrastructureEnumsPotentialConsequenceOptionEnum)[keyof typeof networkInfrastructureEnumsPotentialConsequenceOptionEnum];

export type NetworkInfrastructureEnumsPotentialConsequenceOption =
    NetworkInfrastructureEnumsPotentialConsequenceOptionEnumKey;
